import { defineRouting } from "next-intl/routing";

export const routing = defineRouting({
  locales: ["hu", "en", "uk"],
  defaultLocale: "hu",
  localePrefix: "never",
  localeCookie: {
    maxAge: 60 * 60 * 24 * 365,
  },
});
